import classes from "./Home.module.css";
import { useNavigate } from "react-router-dom";
import refreshToken from "../../functions/refreshToken";
import checkToken from "../../functions/checkToken";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import logo from "../../assets/Logo_Main.png";

function Home() {
  const navigate = useNavigate();
  checkToken(navigate);
  refreshToken();

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      localStorage.clear();
      navigate("/login");
    }
  }, [navigate]);

  const [routeData, setRouteData] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  function lunchRouting(index) {
    const selectedContentName = routeData.contents[index].name;
    localStorage.setItem("selectedContentName", selectedContentName);

    navigate("/AppRoute", {
      state: {
        pathObj: routeData.contents[index],
        parent: selectedContentName,
      },
    });
  }

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !loaded) {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/bucket/list/Packages`,
        requestOptions
      )
        .then((response) => {
          if (response.status === 401) {
            toast.error(
              "شما به محتوا دسترسی ندارید لطفا با پشتیبانی تماس بگیرید"
            );
            localStorage.clear();
            navigate("/login");
            return;
          }
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          if (data) {
            setRouteData(data);
            setLoaded(true);
          }
        })
        .catch((error) => {
          setError(error.message);
          toast.error("خطایی رخ داد. لطفا مجددا تلاش کنید.");
        });
    }
  }, [loaded, navigate]);

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginTop: "120px",
          direction: "rtl",
        }}
      >
        <img src={logo} alt="negar-khodro" style={{ width: "250px" }} />
        <h6 style={{ fontSize: "large" }}>
          لطفا مجدداً تلاش کنید یا با پشتیبانی تماس بگیرید.
          <small style={{ marginTop: "0px" }}>
            ( در صورت روشن بودن فیلتر شکن ان را خاموش کنید)
          </small>
        </h6>
      </div>
    );
  }

  return (
    <div className={classes.HomeCard}>
      <div className={classes.section_map} onClick={() => lunchRouting(0)}>
        <p className={classes.home_text}>
          {loaded
            ? routeData?.contents[0]?.name || "داده ای یافت نشد !"
            : "در حال بارگذاری ..."}
        </p>
      </div>
      <div className={classes.section_ecu} onClick={() => lunchRouting(1)}>
        <p className={classes.home_text}>
          {loaded
            ? routeData?.contents[1]?.name || "داده ای یافت نشد !"
            : "در حال بارگذاری ..."}
        </p>
      </div>

      <div className={classes.section_remap} onClick={() => lunchRouting(2)}>
        <p className={classes.home_text}>
          {loaded
            ? routeData?.contents[2]?.name || "داده ای یافت نشد !"
            : "در حال بارگذاری ..."}
        </p>
      </div>
      <div className={classes.section_electro} onClick={() => lunchRouting(3)}>
        <p className={classes.home_text}>
          {loaded
            ? routeData?.contents[3]?.name || "داده ای یافت نشد !"
            : "در حال بارگذاری ..."}
        </p>
      </div>
      <div className={classes.section_multi} onClick={() => lunchRouting(4)}>
        <p className={classes.home_text}>
          {loaded
            ? routeData?.contents[4]?.name || "داده ای یافت نشد !"
            : "در حال بارگذاری ..."}
        </p>
      </div>
      <div className={classes.section_motorcycle} onClick={() => lunchRouting(5)}>
        <p className={classes.home_text}>
          {loaded
            ? routeData?.contents[5]?.name || "داده ای یافت نشد !"
            : "در حال بارگذاری ..."}
        </p>
      </div>
    </div>
  );
}

export default Home;
